// delete-account/style.js
import { COLORS, RADIUS, FONTS, fontFamilyFor } from "../theme";

export const CustomStyle = {
  pageContainer: {
    maxWidth: "420px",
    margin: "0 auto",
    minHeight: "100vh",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: COLORS.dark,
  },

  heading: (isArabic) => ({
    fontSize: "22px",
    fontWeight: 600,
    fontFamily: isArabic ? fontFamilyFor("ar") : FONTS.heading,
    color: "#fff",
    textAlign: "center",
    direction: isArabic ? "rtl" : "ltr",
    marginBottom: "8px",
  }),

  subHeading: (isArabic) => ({
    fontSize: "14px",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    color: "#9CA3AF",
    textAlign: "center",
    direction: isArabic ? "rtl" : "ltr",
    marginBottom: "32px",
  }),

  label: (isArabic) => ({
    fontSize: "14px",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    color: "#fff",
    marginBottom: "8px",
    direction: isArabic ? "rtl" : "ltr",
  }),

  otpContainer: {
    marginBottom: "32px",
  },

  otpInput: {
    width: "100%",
    backgroundColor: COLORS.gray,
    color: "#fff",
    borderRadius: RADIUS.input,
    "& input": {
      color: "#fff",
      padding: "14px",
    },
  },

  button: (isArabic) => ({
    marginTop: "12px",
    direction: isArabic ? "rtl" : "ltr",
  }),
};
